import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import {AnalyticsService} from '../../../../_services';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-analyticstats',
  templateUrl: './analyticstats.component.html',
  styleUrls: ['./analyticstats.component.css']
})
export class AnalyticstatsComponent implements OnInit {
  @Input('details') details: any;
  saving = false;
  @Output() saveAnalytics = new EventEmitter();
  @Output() modifyAnalytics = new EventEmitter();
  full_analytics: any;
  response: any;
  lender_id: any;
  borrower_id: any;
  principal: any;
  maturity_date: any;
  account_card_id: any;
  loan_request_id: any;
  card_id: any;
  analytics_score: any;
  constructor(private _location: Location,  private analyticsService: AnalyticsService,
              private http: HttpClient) {
  }

  ngOnInit() {
    // this.getAnalytics();
  }
  saveSMSAnalyticsResult() {
    this.saveAnalytics.emit();
  }
  modifyAnalyticsResult() {
    this.modifyAnalytics.emit();
  }
  goBack() {
    this._location.back();
  }
  // getAnalytics() {
  //   return new Promise((resolve, reject) => {
  //     return this.http
  //       .post<any>(`https://eligibilitytest.creditclan.com/public/requestparams`, {
  //         request_id: '13126'
  //       })
  //       .toPromise()
  //       .then(res => {
  //         //console.log(res);
  //         this.lender_id = res.lender_id;
  //         this.borrower_id = res.borrower_id;
  //         this.principal = res.principal;
  //         this.maturity_date = res.maturity_date;
  //         this.account_card_id = res.account_card_id;
  //         this.loan_request_id = res.loan_request_id;
  //         this.card_id = res.card_id;
  //         resolve();
  //       })
  //       .then(() => this.getFullAnalytics())
  //       .catch(err => {
  //         //console.log(err);
  //         // reject();
  //       });
  //   });
  // }
  // getFullAnalytics() {
  //   //console.log(this.lender_id);
  //   return this.analyticsService
  //     .getFullAnalytics(
  //       this.lender_id,
  //       this.borrower_id,
  //       this.principal,
  //       this.maturity_date,
  //       this.account_card_id,
  //       this.loan_request_id,
  //       this.card_id
  //     )
  //     .subscribe(data => {
  //       this.analytics_score = data.profile;
  //     });
  // }
}
